var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"bng-toto-loading"},[_vm._v("Loading...")]):_c('div',{staticClass:"columns"},[_c('iframe',{ref:"totoIframe",staticClass:"column bng-toto-frame",attrs:{"src":_vm.frameUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/toto/toto.vue?vue&type=template&id=1123e0e6
// module id = dmnL
// module chunks = 0